import React from "react";
import { IconX, IconFileX } from "@tabler/icons-react";
import SubmitButton from "../../Users/_components/SubmitButton";
import { useLanguage } from "../../../context/LanguageContext";

interface DeletePickingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pickupId: string | null;
}

const DeletePickingModal: React.FC<DeletePickingModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  pickupId,
}) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <>
      {/* <div className="fixed inset-0 z-[250] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
        <div className="w-full max-w-[450px] relative animate-in fade-in zoom-in duration-300"> 
          <div className="flex items-center">
            <div className="bg-[#FDF8E5] flex items-center justify-between px-8 py-5 w-full rounded-tl-[40px] rounded-tr-[80px] shadow-sm">
              <h3 className="text-xl font-bold text-[#212121]">
                Delete Picking
              </h3>
            </div>
            <div className="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={38}
                height={37}
                viewBox="0 0 38 37"
                fill="none"
                className="absolute -bottom-[1px] -left-[30px] rotate-[-2deg]"
              >
                <path
                  d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                  fill="#FCFDF8"
                />
              </svg>
              <button
                onClick={onClose}
                className="bg-[#F2F2F7] hover:bg-gray-200 rounded-full p-1 cursor-pointer w-12 h-12 ml-4 flex items-center justify-center flex-shrink-0 shadow-sm border border-white/50 transition-all"
              >
                <IconX size={20} className="text-[#212121]" />
              </button>
            </div>
          </div>  
          <div className="bg-[#FCFDF8] rounded-b-[40px] rounded-tr-[40px] -mt-1 p-10 flex flex-col items-center shadow-2xl border-t border-white/20">
          
            <div className="relative mb-8 transform hover:scale-110 transition-transform duration-300">
              <div className="w-28 h-28 bg-[#FFF5F5] rounded-[32px] flex items-center justify-center shadow-inner">
                <IconFileX size={54} className="text-[#FF4848] opacity-10" />
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg
                  width="70"
                  height="80"
                  viewBox="0 0 60 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 0C2.23858 0 0 2.23858 0 5V65C0 67.7614 2.23858 70 5 70H55C57.7614 70 60 67.7614 60 65V15L45 0H5Z"
                    fill="#FFE4D6"
                  />
                  <rect
                    x="15"
                    y="25"
                    width="30"
                    height="4"
                    rx="2"
                    fill="#FF9A6C"
                  />
                  <rect
                    x="15"
                    y="35"
                    width="30"
                    height="4"
                    rx="2"
                    fill="#FF9A6C"
                  />
                  <rect
                    x="15"
                    y="45"
                    width="20"
                    height="4"
                    rx="2"
                    fill="#FF9A6C"
                  />
                  <circle
                    cx="45"
                    cy="50"
                    r="13"
                    fill="white"
                    className="shadow-sm"
                  />
                  <circle cx="45" cy="50" r="11" fill="#FF4848" />
                  <path
                    d="M41 46L49 54M49 46L41 54"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>

            <p className="text-2xl font-black text-[#212121] mb-2 text-center italic">
              Are you sure?
            </p>
            <p className="text-gray-500 text-sm font-medium mb-10 text-center px-6">
              Want to Delete this Picking? This action cannot be undone.
            </p>
 
            <div className="flex flex-col w-full gap-3">
              <button
                onClick={onConfirm}
                className="w-full bg-[#FBD037] hover:bg-[#f2c62c] text-[#212121] font-black py-4 rounded-2xl shadow-lg shadow-[#FBD037]/20 transition-all transform active:scale-95 text-lg"
              >
                Delete
              </button>
              <button
                onClick={onClose}
                className="w-full py-4 text-gray-400 font-bold hover:text-gray-600 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div> */}
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-6">
        <div className="relative w-full rounded-2xl bg-white shadow-xl max-w-md"> 
          <div className="flex flex-col items-center px-6 py-10 space-y-4 text-center"> 
            <div className="w-20 h-20 bg-[#FFF5F5] rounded-[32px] flex items-center justify-center shadow-inner">
              <IconFileX size={54} className="text-[#FF4848] opacity-10" />
            </div>

            <div>
              {/* Title */}
              <h2 className="text-2xl font-semibold text-[#212121]">
                {t("Are you sure ?")}{" "}
              </h2>

              {/* Subtitle */}
              <p className=" text-gray-600 text-base leading-6">
                {" "}
                {t("Want to Delete this Picking? This action cannot be undone.")}{" "}
              </p>
            </div>

            <div className=" flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-center sm:gap-4">
              <button
                onClick={onClose}
                className="w-full sm:w-auto rounded-full border border-gray-300 bg-white px-6 py-2 text-base font-medium text-gray-700 hover:bg-gray-100 transition"
              >
                {t("Cancel")}
              </button>

              <SubmitButton onClick={onConfirm} type="button">
                {t("Delete")}
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeletePickingModal;
